/** Collection name pattern: crh_questions_{localeString} (one collection per locale). */
export function getTypesenseCollectionName(localeString: string): string {
  return `crh_questions_${localeString}`;
}
